var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-product-tile__header" },
    [
      _c(
        "div",
        {
          staticClass: "rb-product-tile__promo-info",
          class: { "--loading": _vm.isLoading },
        },
        [
          _vm.currentPromotion.badge && !_vm.isLoading
            ? _c("rb-promo-badge", {
                attrs: { promo: _vm.currentPromotion.badge },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedVariant.statusMessage ||
          (_vm.currentPromotion.formattedRemainingTime && !_vm.isLoading)
            ? _c("rb-product-tile-status-message", {
                attrs: {
                  message: _vm.selectedVariant.statusMessage,
                  "is-flash": _vm.currentPromotion.isFlash,
                  "formatted-remaining-time":
                    _vm.currentPromotion.formattedRemainingTime,
                  "is-member-access": _vm.selectedVariant.onSale,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading
            ? _c("rb-dummy-skeleton", { staticClass: "--badge" })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("rb-dummy-skeleton", { staticClass: "--wishlist" })
        : _vm.wishlistIconIsVisible
        ? _c(
            "button",
            {
              staticClass: "rb-product-tile__wishlist --no-click",
              attrs: {
                tabindex: _vm.whishlistButtonTabIndex,
                "aria-label": "toggle wishlist",
              },
              on: { click: _vm.toggleWishlist },
            },
            [
              _c("rb-lazy-icon", {
                staticClass: "--no-click",
                attrs: { text: "toggle wishlist", icon: _vm.wishlistHeart },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }